import { useMemo } from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { Deal } from '../../../gql/dealGql';

import { getUnseenMessageNotificationsCount } from '../../../constants/notifications';
import { useUser } from '../../../hooks/useUser';
import TextNotificationBadgeV2 from '../../NotificationBadge/TextNotificationBadgeV2';

type TitleTableNameProps = {
  deal: Deal;
};

const TitleTableName = ({ deal }: TitleTableNameProps) => {
  const user = useUser();
  const unseenNotificationsCount = useMemo(
    () => getUnseenMessageNotificationsCount(user.id, { notifications: deal.notifications }),
    [user.id, deal.notifications],
  );
  if (!deal?.customer) {
    return null;
  }
  return (
    <Flex align="center" gap={1}>
      <TextNotificationBadgeV2 count={unseenNotificationsCount} deal={deal} />
      <Text>{`${deal.customer.first_name} ${deal.customer.last_name}`}</Text>
    </Flex>
  );
};

export default TitleTableName;
